import { Link } from "react-router-dom";
import React, { useState } from "react";
import Navbar from "../Navbar/Main";
import Footer from "../Footer/Main";
import ShareToolsBar from "../Publications/ShareToolsBar";
import PageFeedbackCard from "../Publications/PageFeedbackCard";
import categoryInfo from "../../categoryInfo.json";
import "../Publications/PublicationsMain.css";

export default function Service() {
  const [post] = useState(() => categoryInfo.monetarypolicy ?? []);

  const sectionImageSrc = (path) => {
    if (!path) return "";
    if (path.startsWith("http")) return path;
    return `/${String(path).replace(/^\//, "")}`;
  };

  return (
    <>
      <Navbar />
      <div className="stricky-header stricked-menu main-menu">
        <div className="sticky-header__content"></div>
      </div>
      <nav className="publications-bnr-breadcrumb-bar" aria-label="Breadcrumb">
        <div className="container">
          <ol className="publications-bnr-breadcrumb">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li className="publications-bnr-breadcrumb__sep" aria-hidden="true">
              ›
            </li>
            <li aria-current="page">Monetary Policy</li>
          </ol>
        </div>
      </nav>

      <section className="publications-bnr-hero" aria-labelledby="monetary-policy-bnr-heading">
        <div className="publications-bnr-hero__bg" aria-hidden="true" />
        <div className="publications-bnr-hero__overlay" aria-hidden="true" />
        <div className="container">
          <div className="publications-bnr-hero__card">
            <div className="d-flex flex-wrap align-items-start justify-content-between gap-3">
              <div className="flex-grow-1" style={{ minWidth: "min(100%, 16rem)" }}>
                <h1 id="monetary-policy-bnr-heading" className="publications-bnr-hero__title">
                  Monetary Policy
                </h1>
                <span className="publications-bnr-hero__title-line" aria-hidden="true" />
                <p className="small publications-bnr-hero__tagline mt-2 mb-0">
                  Framework, implementation and communication
                </p>
              </div>
              <div className="flex-shrink-0">
                <ShareToolsBar pageTitle="Monetary Policy — National Bank of Rwanda" />
              </div>
            </div>
            <div className="publications-bnr-hero__lead">
              <p>
                Monetary policy is the process by which a central bank manages the supply and demand of
                money and credit in an economy to achieve specific macroeconomic objectives. The primary
                objective of monetary policy is to promote price stability, which is typically defined
                as low and stable inflation.
              </p>
              <p>
                Explore the Monetary Policy Committee, framework, strategy, implementation and related
                pages below.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="service-five publications-zigzag pt-40 pb-30">
        <div className="container">
          {post.length === 0 ? (
            <p className="text-center text-muted py-4">Loading…</p>
          ) : (
            post.map((p, i) => (
              <div
                className={`row align-items-stretch align-items-lg-center g-4 publications-zigzag__row ${
                  i % 2 === 1
                    ? "flex-lg-row-reverse publications-zigzag__row--photo-left"
                    : "publications-zigzag__row--photo-right"
                }`}
                key={`zigzag-${p.id}`}
              >
                <div className="col-12 col-lg-6 publications-zigzag__text">
                  <h3 className="publications-zigzag__title-heading">
                    <Link to={p.link} className="publications-zigzag__title">
                      {p.title}
                    </Link>
                  </h3>
                  <span className="publications-zigzag__title-line" aria-hidden="true" />
                  <p className="publications-zigzag__summary">{p.summary}</p>
                  <Link to={p.link} className="publications-zigzag__cta">
                    <span className="publications-zigzag__cta-icon" aria-hidden="true">
                      <i className="fa fa-angle-right" />
                    </span>
                    <strong className="publications-zigzag__cta-label">View {p.title}</strong>
                  </Link>
                </div>
                <div className="col-12 col-lg-6 publications-zigzag__media">
                  <Link to={p.link} className="publications-zigzag__img-link" aria-label={`Open ${p.title}`}>
                    <img
                      src={sectionImageSrc(p.image)}
                      alt={p.title}
                      className="publications-zigzag__img"
                      loading="lazy"
                      decoding="async"
                    />
                  </Link>
                </div>
              </div>
            ))
          )}
        </div>
      </section>
      <Footer />
    </>
  );
}
